import React, { useState, useEffect } from "react";
import { FiEdit3 } from "react-icons/fi";
import styles from "../../../styles/CompanyManagement/CompanyDetails.module.css";
import axiosInstance from "../../../utils/api";

const fields = [
  { label: "Brand tone", name: "brandTone", type: "text" },
  { label: "Writing style", name: "writingStyle", type: "text" },
];

const BrandPersonality = ({ companyId }) => {
  // If there is no company yet, start in editing mode so the user can fill the form
  const [isEditing, setIsEditing] = useState(!companyId);
  const [formData, setFormData] = useState({});

  // Fetch existing data when a valid companyId is present
  useEffect(() => {
    if (!companyId) {
      // If companyId is absent, keep the component in editing mode to let user fill the form
      setIsEditing(true);
      return;
    }
    axiosInstance.get(`/api/v1/companies/${companyId}`)
      .then(res => {
        const brandPersonality = res.data.additional_infos?.brand_personality || {};
        setFormData({
          brandTone: brandPersonality.brand_tone || brandPersonality.brandTone || "",
          writingStyle: brandPersonality.writing_style || brandPersonality.writingStyle || ""
        });
        setIsEditing(false);
      });
  }, [companyId]);



  const handleEditClick = () => setIsEditing(true);
  const handleSaveClick = async () => {
    if (!companyId) return;
    // Fetch the latest additional_infos to avoid overwriting other sections
    const res = await axiosInstance.get(`/api/v1/companies/${companyId}`);
    const existing = res.data.additional_infos || {};
    await axiosInstance.patch(`/api/v1/companies/${companyId}`, {
      company: {
        additional_infos: {
          ...existing,
          brand_personality: {
            brand_tone: formData.brandTone || "",
            writing_style: formData.writingStyle || ""
          }
        }
      }
    });
    setIsEditing(false);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <div className={styles.detailsHeader}>
        <span className={styles.detailsHeading}>{!companyId ? "Create Brand personality" : "Brand personality"}</span>
        {!isEditing ? (
          <button className={styles.editBtn} onClick={handleEditClick}>
            <FiEdit3 /> Edit
          </button>
        ) : (
          <button className={styles.saveBtn} onClick={handleSaveClick}>
            Save
          </button>
        )}
      </div>
      <div className={styles.separator} />
      <div className={styles.detailsContent}>
        {fields.map((field) => (
          <div className={styles.detailItem} key={field.name}>
            <span className={styles.detailLabel}>{field.label}</span>
            {isEditing ? (
              <input
                type={field.type}
                name={field.name}
                value={formData[field.name] || ""}
                onChange={handleChange}
              />
            ) : (
              <p>{formData[field.name]}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandPersonality;